<template>
    <div class="clienteling">
         <v-toolbar flat class="sub-toolbar">
            <div class="back mr-auto pl-3 d-flex align-center">
                <v-text-field class="pt-0" type="text" id="busq" placeholder="Buscar cliente..." v-model="busqueda" @keyup.enter="filtrarBusqueda(0)" @keyup="gestionarBotones" autocomplete="off" :class="{'vacio': deshabilitado}">
                </v-text-field>
                <v-btn icon flat class="borrar" v-if="deshabilitado || busqueda !== ''" @click="reset">
                    <v-icon class="primary-color">close</v-icon>
                </v-btn>
                <v-btn icon flat class="lupaicon" @click="filtrarBusqueda(0)">
                    <!-- <img src="@/assets/css/icons/flaticon/loupe.svg" width="20" height="20"/> -->
                    <v-icon class="primary-color">search</v-icon>
                </v-btn>
            </div>    
            <v-btn text flat class="primary-color" @click="dialog = !dialog" >
                <v-icon class="mr-2">person_add</v-icon>
                Añadir cliente
            </v-btn>
        </v-toolbar>    
        
        <div>
            <div v-if="cargando" class="cargando">
                <v-progress-circular
                    indeterminate
                    color="#2562a4"
                ></v-progress-circular>
            </div>
            <div v-else>
                <div v-if="Object.keys(clientes).length > 0" class="px-2 pt-0 list-container">
                    <v-card v-for="(cliente,index) in clientes.content" :key="index" class="ma-2 elevation-1" @click="irACliente(cliente)">
                        <div class="pa-2">
                                <div class="primary-color d-flex h3 text-uppercase display-2">
                                    <!--<img class="ml-1 mb-2 mr-1" src="@/assets/css/icons/flaticon/user.svg" width="18" height="20" />-->
                                    <v-icon class="primary-color no-flex mr-2">person_pin_circle</v-icon>
                                    <p class="subheading mb-0 font-weight-medium">{{cliente.nombre}} </p>
                                </div>     
                            
                            <v-list class="pl-5 pt-0">
                                    <p class="ma-0 "> {{cliente.movil === '' ? cliente.telefonoUno ==='' ? cliente.telefonoDos : cliente.telefonoUno : cliente.movil }}</p>
                                    <p class="ma-0">789738X</p>
                                    <p class="ma-0"> {{cliente.email}}</p>
                            </v-list>    
                            </div>            
                    </v-card>
                        
                    <div id="footer" class="text-center">
                        <v-pagination 
                            v-model="page"
                            :length="totalPag"
                            total-visible="6"
                            @input="cambioPagina"
                        >
                        </v-pagination>
                    </div>    
                </div>  
                <div class="no-productos mt-5" v-else>
                    <v-alert
                        :value="true"
                        color="primary"
                        class="mx-5 primary-color"
                        outline
                        ><v-icon class="mr-2">search_off</v-icon> No hay clientes
                    </v-alert>
                </div>
            </div>     
            <transition name="modal">
                    <v-dialog v-model="dialog" name="search1" class="pa-0">
                        <div  class="pa-0 search">
                        <v-toolbar flat class="d-flex justify-space-between">
                        <v-toolbar-title class="primary-color">
                            <v-icon class="mr-3 primary-color">person_add</v-icon>
                            Crear nuevo cliente</v-toolbar-title>
                        <v-btn @click="dialog = false"
                            icon
                            flat
                            class="primary-color">
                        <!--<img class='btn-footer-izq pointer' src='@/assets/images/Btn-ESC.gif' >-->
                        <!--{{ $t('lang.comun.salir') }}-->
                        <v-icon>close</v-icon>
                        </v-btn></v-toolbar>
                        <CreateCliente />
                        </div>
                    </v-dialog>
                <!--<modal-alta-cliente class="modal-overlay" v-if="modal" @close="modal = false"></modal-alta-cliente>-->
            </transition>   
        </div>    
    </div>    
</template>

<script>
    import { ClienteApiService } from '@/api/ClienteApiService';
    import ModalAltaCliente from './ModalAltaCliente';
    import CreateCliente from './ModalAltaCliente';
    const clienteApi = new ClienteApiService()
    export default {
        components: {
            ModalAltaCliente,
            CreateCliente
        },
        data() {
            return{
                deshabilitado:false,
                page: this.$store.getters.getNpag,
                totalPag:0,
                clientes:[],
                listaclientes:[],
                filtro: 0,
                modal: false,
                busqueda: '',
                dialog: false,
                cargando: false
            }
        },
        computed:{
            cambioPag(){
                return this.$store.getters.getNpag;
            },
            cliente () {
                return this.$store.getters.getCliente
            },
            busquedaCliente () {
                return this.$store.getters.getBusquedaCliente
            }
        },
        watch:{
            cambioPag(pag){
                if (this.page !== pag)
                    this.page = pag
            },
            cliente(value) {
                if (value !== null) {
                    this.$router.push({name: 'cliente'})
                }
            },
            busquedaCliente (value) {
                if (value !== '') {
                    this.busqueda = value
                    this.filtrarBusqueda(0)
                }
            }
        },
        created() {
            if (this.cliente !== null) {
                this.$router.push({name: 'cliente'})
            }
            this.$store.commit('cambioPag', 1)
            this.listaclientes = this.clientes;
            this.sacarDatos()    
            this.cambioTitulo()
        },
        mounted() {
            if (this.busquedaCliente !== '') {
                this.busqueda = this.busquedaCliente
                this.filtrarBusqueda(0)
            }
        },
        methods: {
                cambioTitulo() {
                    this.$store.state.tituloIcono = '<v-icon class="primary-color v-icon material-icons no-flex mr-2">person_pin_circle</v-icon>'
                    this.$store.state.titulo = 'Clientes'
                },
                irACliente(cliente) {
                   this.$store.dispatch("setCliente", cliente)
                   this.$router.push({name: 'cliente'})
                },
            //Método para gestionar los botones de las letras como de la busqueda
                gestionarBotones(){
                    if(this.busqueda == ""){
                        this.deshabilitado = false;
                        this.sacarDatos();
                    }
                    else
                    {
                        this.deshabilitado = true;
                    }
                },
            
            //Método para resetear la busqueda
                reset(){
                    this.clientes = []
                    this.busqueda = "";
                    this.filtro = 0;
                    this.gestionarBotones();
                    this.page = 1;
                    this.sacarDatos();
                },
                
            //Método para filtrar por busqueda
                filtrarBusqueda(dato){
                    let valor = this.busqueda;
                    this.cargando = true
                    if (valor != ""){
                        this.filtro = 1;
                        clienteApi.getClientesFilter(valor,dato)
                        .then(data => {
                            this.cargando = false
                            if (data.content.length == 0)
                                this.clientes = [];
                            else    
                            {
                                this.clientes = data;
                                this.totalPag = this.clientes.totalPages;
                            }
                        })
                    }
                    
                },
                
            //Metodo para cojer los datos del cliente    
                sacarDatos(){
                    // clienteApi.getAllClientes(this.page -1)
                    // .then(data => {
                    //     this.clientes = data;
                    //     this.totalPag = this.clientes.totalPages;
                    // })
                },
            //Metodo para cambiar la pagina
                cambioPagina(){
                    this.$store.commit('cambioPag', this.page);
                    switch (this.filtro){
                        case 0:
                            this.sacarDatos();
                        break;
                        default:
                            this.filtrarBusqueda(this.page -1);
                        break;    
                    }
                },
            //Metodo para abrir el modal    
                openModal() {
                    this.modal = true
                }    
        },  
    }
</script>
<style scoped>
 /*  .header{
        width: 95%;
        margin: 0 auto;
    }

    #busq{
        color: #27629D;
        font-size: 11pt;
        background-color: rgba(39,98,157,0.2) !important;
        border-radius: 50px !important;
    }

    #busq.vacio{
        border-radius: 50px 0 0 50px !important;
    }

    ::-webkit-input-placeholder{
        color: #27629D;
    }

    .lupaicon{
        margin-left: 5px;
    }

    .buscador{
        display: flex;
        padding-top: 10px;
    }

    .datoscliente{
        padding-left: 15px;
        padding-right: 15px;
    }

    .lista{
        display: flex;
        justify-content: space-between;
        width: 95%;
        flex-wrap: wrap;
        margin: 0 auto;
        padding-bottom: 60px;
    }
    .lista button {
        border: none;
        box-shadow: 1px 1px 10px 0 #707070;
    }

    .lista button:hover{
        background: lightgray;
    }

    .lista button:focus{
        outline: 0;
        outline-width: 0 !important;
    }

    .buscador{
        width: 40%;
    }

    .buscador button{
        width: 40px;
    }

    .buscador .borrar{
        border-left: 0;
        background-color: rgba(39,98,157,0.2) !important;
        border-radius: 0 50px 50px 0;
        border-color: #f3f3f3;
        color: #27629D;
        font-weight: bold;
    }

    .buscador button:nth-of-type(2), #busq:focus{
        outline: 0;
        outline-width: 0 !important;
        box-shadow: none;
        border-color: lightgray;
    }

    .botoncli{
        padding-top: 15px;
        padding-bottom: 15px;
        width: 48%;
        background-color: white;
        margin-top: 35px;
    }

    .datoscliente .cabecera{
        color: #27629D;
        font-weight: bold;
        font-size: 11pt;
        border-bottom: 1px solid #C8C8CC;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    h5{
        padding-top: 10px;
    }

    .anadircli{
        float: right;
        background-color: #27629D;
        color: white;
        padding: 5px;
        border-radius: 20px;
        padding-left: 10px;
        padding-right: 15px;
        font-size: 10pt;
        margin-top: -33px;
    }
    @media (min-width:950px){
        .buscador{
            width: 30%;
        }
    }
    
    @media (max-width: 760px){
        .lista{
            width: 100% !important;
        }
       
        .botoncli{
            width: 100% !important;
            background-color: white;
            margin-top: 25px;
        }

        .header{
            width: 100%;
        }
        
        .buscador{
            width: 50%;
            padding-bottom: 5px;
        }

        .botoncli:nth-child(10){
            margin-bottom: 70px !important;
        }
    } */
</style>